export default __webpack_public_path__ + "static/slider_1-424a3eaddc9a2c34d61efdede1bd1e9b.png";